import axiosInstance from "../../axios";
import AXIOS_ROUTES from "../../axios/routes";
import {
  ICreateVodPayload,
  IUpdateVodPayload,
} from "../../interfaces/store/vod-interface";

export const getVodApi = async (id: string) => {
  return await axiosInstance.get(`${AXIOS_ROUTES.vods.getVod}?vodId=${id}`);
};

export const createVodApi = async (data: ICreateVodPayload) => {
  return await axiosInstance.post(AXIOS_ROUTES.vods.createVod, data.vod);
};

export const updateVodApi = async ({ vodId, vod }: IUpdateVodPayload) => {
  return await axiosInstance.put(
    `${AXIOS_ROUTES.vods.updateVod}?vodId=${vodId}`,
    vod
  );
};

export const deleteVodApi = async (vodId: string) => {
  return await axiosInstance.delete(
    `${AXIOS_ROUTES.vods.deleteVod}?vodId=${vodId}`
  );
};

export const searchVodsApi = async (data: any) => {
  return await axiosInstance.post(AXIOS_ROUTES.vods.search, data);
};
